function NewRegion() {
    return {
        id: null,       
        name: "",		
		channels: [],
        _isNew: true
      }
}
export default NewRegion;